import React from 'react'
import Text from '@amzn/meridian/text'
import Column from '@amzn/meridian/column'
import { useBundle } from '@amzn/react-arb-tools'
import { BUNDLE_NAME } from '@src/constants'
import { t } from '@src/translationHelper'
import { NO_STORES_FOUND } from '../constants'

interface IEmptyStateProps {
    /** Panther string identifier of the message to show, defaulting to 'no stores found'. */
    messageStringId?: string
}

/**
 * EmptyState Component
 *
 * Displays a message when no stores match the search query.
 */
export const EmptyState: React.FC<IEmptyStateProps> = ({ messageStringId }) => {
    const [bundle] = useBundle(BUNDLE_NAME)

    return (
      <Column alignmentHorizontal="center" spacingInset="500 400">
        <Text>{t(bundle, messageStringId || NO_STORES_FOUND)}</Text>
      </Column>
    )
}
